import { createSelector } from '@reduxjs/toolkit';
import { selectJsonQuery } from './selectJsonQuery';
import { getTermValue } from '../../../packages/JsonQuery';
import { ECoworkingAccess } from '../../../packages/JsonQuery/types/coworkingAccess';

export const selectCoworkingAccess = createSelector(selectJsonQuery, jsonQuery => {
  const allDay = getTermValue('all_day_access')(jsonQuery);
  const allWeek = getTermValue('all_week_access')(jsonQuery);
  const result: ECoworkingAccess[] = [];

  if (allDay) {
    result.push(ECoworkingAccess.AllDayAccess);
  }
  if (allWeek) {
    result.push(ECoworkingAccess.AllWeekAccess);
  }

  return result.length > 0 ? result : null;
});
